<template>
  <div class="logos">
    <a href="http://www.broadinstitute.org/" target="_blank">
      <img src="./img/Broad.png" alt="Broad Institute" title="Broad Institute" />
    </a>
  </div>
</template>

<style scoped>
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
img {
  height: clamp(20px, 3.5vw, 45px);
  width: auto;
  vertical-align: middle;
}
</style>
